import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyCustomerTopSales = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/customers/summary/top/sales',
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,
    },
};
